/** Turn snake_case / kebab codes into short title labels for dense tables. */
export function formatCodeLabel(code: string | null | undefined): string {
  if (!code?.trim()) return '—'
  return code
    .trim()
    .split(/[_-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ')
}
